<form [formGroup]="formGroup">

  <div class="d-flex flex-row flex-nowrap align-items-center">
    <label class="switch" for="isPublic">
      <input type="checkbox" formControlName="isPublic" id="isPublic" #isPublicCheckbox>
      <span class="slider round" (click)="$event.stopPropagation()"></span>
    </label>
    <span class="ps-2 cursor-pointer user-select-none flex-1" i18n="@@projects.tab.template.isPublic"
          (click)="isPublicCheckbox.click()">Public Access to the Project</span>
  </div>

  <div class="mt-4" formGroupName="metadata" *ngIf="isPublicControl.value">

    <div class="alert alert-danger" role="alert">
      Danger zone: All the data available in this project are now publicly visible. Anyone can get access to this
      project and
      copy all the data.<br/>
      Only project users will have the write access. Nobody outside of your organization and project can modify
      anything.
    </div>

    <div class="row m-0 mt-4">
      <label class="col-sm-3 px-0 col-lg-2 col-form-label" for="imageUrl"
             i18n="@@projects.tab.template.metadata.imageUrl">
        Image Address
      </label>
      <div class="col-sm-9 col-lg-10 px-0 mb-2">
        <input class="form-control" type="text" formControlName="imageUrl" id="imageUrl"
               (keydown.enter)="$event.target.blur()"
               inputmode="url"
               (focus)="editingControl = 'imageUrl'"
               (blur)="editingControl = null"
               placeholder="https://..."/>
        <div class="text-muted small px-1 mt-1" i18n="@@projects.tab.template.metadata.imageUrl.help">
          An image used to represent the project in the project creation dialog.
        </div>
      </div>
    </div>

    <div class="row m-0 mt-2">
      <label class="col-sm-3 px-0 col-lg-2 col-form-label" for="allowedDomains"
             i18n="@@projects.tab.template.metadata.allowedDomains">
        Allowed Domains
      </label>
      <div class="col-sm-9 col-lg-10 px-0 mb-2">
        <input class="form-control" type="text" formControlName="allowedDomains" id="allowedDomains"
               (focus)="editingControl = 'allowedDomains'"
               (blur)="editingControl = null"/>
        <div class="text-muted small px-1 mt-1" i18n="@@projects.tab.template.metadata.allowedDomains.help">
          Domains allowed to embed this project. E.g. www.lumeer.io, acme.com.
          Enter * to allow embedding into any web page.
        </div>
      </div>
    </div>

    <div class="row m-0 mt-2">
      <label class="col-sm-3 px-0 col-lg-2 col-form-label" for="relativeDate"
             i18n="@@projects.tab.template.metadata.relativeDate">Relative Date</label>
      <div class="col-sm-9 col-lg-10 px-0 mb-2">
        <input class="form-control" type="text" formControlName="relativeDate" id="relativeDate"
               bsDatepicker
               inputmode="numeric"
               (focus)="editingControl = 'relativeDate'"
               (blur)="editingControl = null"
               [bsConfig]="datePickerConfig"/>
        <div class="text-muted small px-1 mt-1" i18n="@@projects.tab.template.metadata.relativeDate.help">
          When anyone creates a copy of this project, all date values will be shifted.
          The shift is determined as a difference between today and the date specified here.
          No shift is made when left empty.
        </div>
      </div>
    </div>

    <div class="row m-0 mt-2">
      <label class="col-sm-3 px-0 col-lg-2 col-form-label" i18n="@@projects.tab.template.metadata.defaultView">
        Open in View
      </label>

      <div class="col-sm-9 col-lg-10 px-0 mb-2">
        <select-item class="p-0"
                     [items]="views | viewsSelectItems:collections"
                     emptyValue="Select view"
                     i18n-emptyValue="@@projects.tab.template.metadata.defaultView.empty"
                     [removable]="true"
                     [selectedId]="defaultViewControl.value"
                     [fitParent]="true"
                     (selected)="onViewSelected($event)"
                     (remove)="onViewSelected(null)">
        </select-item>
        <div class="text-muted small px-1 mt-1" i18n="@@projects.tab.template.metadata.defaultView.help">
          The view that opens when the project is first loaded in the project creation dialog or embedded view.
          Leave empty for the default home page.
        </div>
      </div>
    </div>

    <div class="row m-0 mt-2">
      <label class="col-sm-3 px-0 col-lg-2 col-form-label"
             i18n="@@projects.tab.template.metadata.tags">Tags</label>

      <input-tags class="col-sm-9 col-lg-10 p-0"
                  (blur)="editingControl = 'tags'"
                  (focus)="editingControl = null"
                  [formGroup]="metadataFormGroup"
                  controlName="tags">
      </input-tags>
    </div>

    <div class="row m-0 mt-2">

      <label class="col-sm-3 px-0 col-lg-2 col-form-label"
             i18n="@@projects.tab.template.metadata.templateProject">This Project is a Template</label>

      <div class="col-sm-9 col-lg-10 p-0 d-flex align-items-center">
        <div class="d-flex flex-row flex-nowrap align-items-center">
          <label class="switch" for="template">
            <input type="checkbox" formControlName="template" id="template" #template>
            <span class="slider round" (click)="$event.stopPropagation()"></span>
          </label>
          <span class="ps-2 cursor-pointer user-select-none flex-1" i18n="@@projects.tab.template.metadata.templateProject.description"
                (click)="template.click()">When turned on, no task notifications will be sent and no timers are automatically executed so that the project can be used as a template for creating other projects.</span>
        </div>
      </div>

    </div>

    <div class="row m-0 mt-2">

      <label class="col-sm-3 px-0 col-lg-2 col-form-label"
             i18n="@@projects.tab.template.metadata.topPanel">Top Panel</label>

      <div class="col-sm-9 col-lg-10 p-0 d-flex align-items-center">
        <div class="d-flex flex-row flex-nowrap align-items-center">
          <label class="switch" for="showTopPanel">
            <input type="checkbox" formControlName="showTopPanel" id="showTopPanel" #showTopPanelCheckbox>
            <span class="slider round" (click)="$event.stopPropagation()"></span>
          </label>
          <span class="ps-2 cursor-pointer user-select-none flex-1" i18n="@@projects.tab.template.metadata.showTopPanel"
                (click)="showTopPanelCheckbox.click()">Show application controls (the upper panel)</span>
        </div>
      </div>

    </div>

  </div>

  <div class="mt-5" formGroupName="script" *ngIf="isPublicControl.value">
    <project-template-script [formGroup]="scriptFormGroup"
                             [views]="views"
                             [collections]="collections"
                             [workspace]="workspace">
    </project-template-script>
  </div>

</form>
